import { OrderInterface } from "../interfaces/orders";

const getTimestampedFilename = (prefix: string) => {
    const pad = (n: number) => n.toString().padStart(2, "0");
    const d = new Date();
    const YYYY = d.getFullYear();
    const MM = pad(d.getMonth() + 1);
    const DD = pad(d.getDate());
    const hh = pad(d.getHours());
    const mm = pad(d.getMinutes());
    const ss = pad(d.getSeconds());
    return `${prefix}_${YYYY}${MM}${DD}_${hh}${mm}${ss}.csv`;
};

export const downloadCSV = (data: string, fileName: string) => {
    let downloadLink = document.createElement("a");
    downloadLink.target = "_blank";
    downloadLink.download = fileName;
    // convert csv data to a Blob
    let blob = new Blob([data], { type: "text/csv;charset=utf-8;" });

    // create an object URL from the Blob
    let URL = window.URL || window.webkitURL;
    let downloadUrl = URL.createObjectURL(blob);

    console.log(downloadUrl);

    // set object URL as the anchor's href
    downloadLink.href = downloadUrl;

    // append the anchor to document body
    document.body.append(downloadLink);

    // fire a click event on the anchor
    downloadLink.click();

    // cleanup: remove element and revoke object URL
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(downloadUrl);
};

export const convertOrdersToCSV = (
    orders: Array<OrderInterface>,
    productNameMapping: Record<string, string>,
    labelsByOrderId: Record<string, Array<string>>,
): string => {
    const header = [
        "Tipologia report",
        "Ragione Sociale",
        "Codice Fiscale",
        "Partita Iva",
        "Etichette",
        "Utente Acquirente",
        "Data Acquisto",
    ];
    const rows = orders.map((order) => [
        productNameMapping[order.product],
        order.name,
        `"${order.fiscal_code}"`,
        `"${order.piva || ""}"`,
        labelsByOrderId[order.order_id] || "",
        order.user_email || "",
        order.request_date,
    ]);
    const csvContent = [header, ...rows].map((e) => e.join(";")).join("\n");
    return csvContent;
};

export const exportOrdersToCSV = (
    orders: Array<OrderInterface>,
    productNameMapping: Record<string, string>,
    labelsByOrderId: Record<string, Array<string>>,
    fileNamePrefix: string,
) => {
    const csvData = convertOrdersToCSV(
        orders,
        productNameMapping,
        labelsByOrderId,
    );
    downloadCSV(csvData, getTimestampedFilename(fileNamePrefix));
};
